export const formVehicleManagementNaming = {
  NEW_VEHICLE_MANAGEMENT_FORM: 'new-vehicle-management-form',
};
